import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { ZitadelUser } from "@src/types/user-management";

export const getSupportAgents = async (namespace: string) => {
  const url = supportUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get<ZitadelUser[]>(
      `${url}/api/v1/ns/${namespace}/users/support-agents`,
      { headers },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch support agents. Please try again later.",
      );
    } else {
      throw new Error(
        "An unexpected error occurred while fetching support agents.",
      );
    }
  }
};
